import { autoLoanDetailsRepository } from '@/forms/api/repository-factory';
import store from '@/store';
import callApiPromo from '@/lib/helpers/call-api-promo';


const getPayload = () => {

    return {
        "ApiName": "get-details-auto",
        "Source": "Auto"
    };
};
export default {

    async getAutoLoanDetails(currentStep, callbacks) {
        const { form } = currentStep;
        // if (store.state.institutions.length === 0) {
        let response = false;
        response = await callApiPromo({
            callbacks,
            form,
            formElement: currentStep,
            apiCallPromo: autoLoanDetailsRepository.getAutoLoanDetails,
            payload: getPayload()
        });

        if (response) {
            var data = response;
            return data;
        }
    }
};